import { Box, Button, HStack, Text, VisuallyHidden } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { $ok } from "foundation-ts/commons";
import { ServiceSupplier } from "@bcasmart/doxecure-commons/doxecureTypes";

import { config } from "@/config/config";
import { $g1Color } from "@/theme/G1Style";
import { authProviders } from "@utils/Provider";

export interface AuthProvidersBoxProps {
    onSelect: (provider: ServiceSupplier) => void ;
    mode: "horizontal" | "vertical" ;
    isMobile?: boolean ;
}

export const AuthProvidersBox = (props: AuthProvidersBoxProps) => {
    const {isMobile, onSelect} = props ;
    const [fontSize, setFontSize] = useState("lg") ;
    const [hover, setHover] = useState(false) ;

    useEffect(() => {
        setFontSize(isMobile ? "md" : "lg") ;
    }, [isMobile]) ;

    return (
        <Box w="100%" mt="6" display="flex" justifyContent="space-around" margin="1em 0">
            {authProviders.map((provider) => (
                $ok(config.providers["chambersign"].clientId) ? 
                    <Button
                        key={provider.slug}
                        variant="outline"
                        padding="0 2px"
                        backgroundColor={$g1Color('connection.provider.bg')}
                        color={$g1Color('connection.provider.write')}
                        onClick={() => onSelect(provider.slug)}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        _hover={{ bg: $g1Color('connection.provider.hover.bg'), color: $g1Color('connection.provider.hover.write') }}
                    >
                        <HStack justifyContent="space-around" marginLeft={5} marginRight={5}>
                            {hover ? provider.hoverIcon : provider.icon}
                            <Text marginRight={10} fontWeight="800" fontSize={fontSize}>{provider.label}</Text>
                        </HStack>
                    </Button>
                :
                    <Button
                        key={provider.slug}
                        variant="outline"
                        padding="unset"
                        onClick={() => onSelect(provider.slug)}
                        _hover={{ bg: $g1Color('connection.provider.hover.bg') }}
                    >
                        <VisuallyHidden>Se connecter avec {provider.label}</VisuallyHidden>
                        {provider.icon}
                    </Button>
            ))}
        </Box>
    ) ;
}